var map = {
	"./Belgium.svg": 627,
	"./NL.svg": 594,
	"./Poland.svg": 528,
	"./UK.svg": 968,
	"./arrow.svg": 412,
	"./calendar.svg": 172,
	"./logo.svg": 925,
	"./ocean.svg": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 289;